/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it
import "lazysizes";

export function onServiceWorkerUpdateReady(){window.location.reload(true)};

// Tawk.to chat removed 2026-07-08: replaced by the WhatsAppChat component
// (src/components/WhatsAppChat.js) — no third-party script, conversations
// land on WhatsApp where contacts are permanent, and the contact form stays
// as the tracked email path.
